export default "__VITE_ASSET__MleBlllN__"